import { Store } from 'pullstate';

export const NotificationStore = new Store({
    nPromotionNotificationManual: {},
    nPromotionNotificationAuto: {},

    nUserOrderCourierAction: {},
});
